import ResetFilterIcon from './ResetFilterIcon'
import DoneFilterIcon from './DoneFilterIcon'

export default { ResetFilterIcon, DoneFilterIcon }
